var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import { GET_REPORTS_META_DATA_SUCCESS, GET_OVERALL_REPORTS_META_DATA_SUCCESS, GET_PROJECTS_SUCCESS } from './reports.actions';
export var initialState = { projects: [], metaData: null, overallMetaData: null };
export function reportsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_PROJECTS_SUCCESS:
            var projects = action.payload.map(function (_a) {
                var id = _a.id, name = _a.name, status = _a.status;
                return ({ id: id, name: name, status: status });
            });
            return __assign({}, state, { projects: projects });
        case GET_REPORTS_META_DATA_SUCCESS:
            return __assign({}, state, { metaData: action.payload });
        case GET_OVERALL_REPORTS_META_DATA_SUCCESS:
            return __assign({}, state, { overallMetaData: action.payload });
        default: {
            return state;
        }
    }
}
var getProjects = function (reportState) { return reportState.projects; };
var ɵ0 = getProjects;
var getMetaData = function (reportState) { return reportState.metaData; };
var ɵ1 = getMetaData;
var getOverallMetaData = function (reportState) { return reportState.overallMetaData; };
var ɵ2 = getOverallMetaData;
export var getMainReportsSelector = function (state) { return state.reports; };
export var getProjectsSelector = createSelector(getMainReportsSelector, getProjects);
export var getMetaDataSelector = createSelector(getMainReportsSelector, getMetaData);
export var getOverallMetaDataSelector = createSelector(getMainReportsSelector, getOverallMetaData);
export { ɵ0, ɵ1, ɵ2 };
